import React from 'react'
import i18n from 'i18next'
import * as R from 'ramda'

import Typography from '../../../UniformComponents/Typography'

const BenchmarkExplainer = ({ store }) => (
    <div>
        <div className="pp-summary-slide-container">
            <img src="https://cdn.explori.com/images/logo_explori.png" alt="explori logo" style={{ width: 120, position: 'absolute', right: 50, top: 50 }} />

            <div className="pp-summary-slide-content" style={{ height: '100%', gap: 20 }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography type="h2">{i18n.t('powerpoint.benchmarkexplainer.title')}</Typography>

                    <br />

                    <Typography>{i18n.t('powerpoint.benchmarkexplainer.text.1', { eventname: R.pathOr('' , ['value', 'product'], store.fullSurveys.values().next())})}</Typography>

                    <ul style={{ marginTop: 10 }}>
                        <li><Typography>{i18n.t('powerpoint.benchmarkexplainer.text.2')}</Typography></li>

                        <br />

                        <li><Typography>{i18n.t('powerpoint.benchmarkexplainer.text.3')}</Typography></li>
                    </ul>
                </div>

                <div style={{ padding: 20, backgroundColor: 'white', borderRadius: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '180px', width: '180px', flexShrink: 0, gap: 10 }}>
                    <i className="fas fa-chart-mixed" style={{ color: '#16CCC1', fontSize: 34 }} />

                    <Typography style={{ color: 'black', textAlign: 'center' }}>{i18n.t('powerpoint.benchmarkexplainer.bubbletext')}</Typography>
                </div>
            </div>
        </div>
    </div>
)

export default BenchmarkExplainer
